/**
 * Helper to get the current Cognito ID token for API calls.
 */
import { fetchAuthSession } from 'aws-amplify/auth';

export async function getAuthHeaders(): Promise<Record<string, string>> {
  const session = await fetchAuthSession();
  const idToken = session.tokens?.idToken?.toString();
  if (!idToken) {
    throw new Error('No active session — user must be signed in');
  }
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${idToken}`,
  };
}
